module.exports = __webpack_public_path__ + "img/4.54100b6b.png";